import { render, staticRenderFns } from "./AddProfile.vue?vue&type=template&id=3f04406c&scoped=true&"
import script from "./AddProfile.vue?vue&type=script&lang=js&"
export * from "./AddProfile.vue?vue&type=script&lang=js&"
import style0 from "./AddProfile.vue?vue&type=style&index=0&id=3f04406c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f04406c",
  null
  
)

export default component.exports